import React from 'react';
import Link from 'next/link';

const services = [
  'IT Staffing Solutions',
  'Executive Search',
  'Contract Staffing',
  'Direct Hire Placement',
  'IT Consulting',
  'Workforce Solutions',
];

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Case Studies', href: '/case-studies' },
  { label: 'Clients', href: '/clients' },
  { label: 'Contact Us', href: '/contact' },
];

export default function Footer() {
  return (
    <footer style={{ background: '#01142D', color: '#ffffff' }}>
      {/* Top accent bar - Pinnacle1 style */}
      <div style={{ height: '4px', background: '#00A7FF' }}></div>

      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link href="/" className="flex items-center gap-3 mb-6 group">
              <div
                className="flex items-center justify-center flex-shrink-0"
                style={{
                  width: '48px',
                  height: '48px',
                  background: '#00A7FF',
                }}
              >
                <span
                  className="font-bold text-white text-base"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  TR
                </span>
              </div>
              <div className="flex flex-col">
                <span
                  className="font-bold text-white leading-tight"
                  style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 700 }}
                >
                  TranceformRIGHT
                </span>
                <span
                  className="leading-none mt-0.5"
                  style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 400, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)' }}
                >
                  IT Staffing &amp; Consulting
                </span>
              </div>
            </Link>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.7', marginBottom: '24px', fontFamily: 'Poppins, sans-serif' }}>
              Premier IT staffing and consulting partner for Fortune 500 companies. Connecting exceptional technology talent with industry-leading organizations.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {[
                { label: 'LinkedIn', path: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z' },
                { label: 'Twitter', path: 'M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z' },
                { label: 'Facebook', path: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z' },
              ]?.map((social) => (
                <a
                  key={social?.label}
                  href="#"
                  aria-label={social?.label}
                  className="w-8 h-8 flex items-center justify-center transition-all duration-200"
                  style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.background = '#00A7FF';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.1)';
                  }}
                >
                  <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d={social?.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="mb-5"
              style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 400, color: '#00A7FF', letterSpacing: '0.02em' }}
            >
              Quick Links
            </h4>
            <div className="w-8 h-0.5 mb-5" style={{ background: '#00A7FF' }}></div>
            <ul className="space-y-3">
              {quickLinks?.map((link) => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    className="flex items-center gap-2 transition-all duration-200"
                    style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00A7FF'; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
                  >
                    <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#00A7FF', opacity: 0.6 }}></span>
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4
              className="mb-5"
              style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 400, color: '#00A7FF', letterSpacing: '0.02em' }}
            >
              Our Services
            </h4>
            <div className="w-8 h-0.5 mb-5" style={{ background: '#00A7FF' }}></div>
            <ul className="space-y-3">
              {services?.map((service) => (
                <li key={service}>
                  <Link
                    href="/services"
                    className="flex items-center gap-2 transition-all duration-200"
                    style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00A7FF'; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
                  >
                    <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#00A7FF', opacity: 0.6 }}></span>
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="mb-5"
              style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 400, color: '#00A7FF', letterSpacing: '0.02em' }}
            >
              Contact Us
            </h4>
            <div className="w-8 h-0.5 mb-5" style={{ background: '#00A7FF' }}></div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: '#00A7FF' }} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.6' }}>
                  24076 Gumspring Kiln Ter<br />Sterling, VA 20166
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-4 h-4 flex-shrink-0" style={{ color: '#00A7FF' }} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a
                  href="tel:+12145550100"
                  style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00A7FF'; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
                >
                  +1 (214) 555-0100
                </a>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-4 h-4 flex-shrink-0" style={{ color: '#00A7FF' }} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a
                  href="mailto:info@tranceformright.com"
                  style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00A7FF'; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
                >
                  info@tranceformright.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}></div>

      {/* Bottom Bar */}
      <div style={{ background: 'rgba(0,0,0,0.2)' }}>
        <div className="container-custom py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p style={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
            &copy; 2024 TranceformRIGHT. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Privacy Policy', 'Terms of Service', 'Sitemap'].map((item) => (
              <a
                key={item}
                href="#"
                style={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#00A7FF'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.5)'; }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
